var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.65c3.075 0 5.587-2.513 5.587-5.588 0-3.074-2.512-5.624-5.587-5.624-3.075 0-5.587 2.512-5.587 5.587 0 3.075 2.512 5.625 5.587 5.625Zm0-9.9a4.273 4.273 0 0 1 4.275 4.275A4.273 4.273 0 0 1 12 12.3a4.273 4.273 0 0 1-4.275-4.275C7.725 5.7 9.638 3.75 12 3.75ZM23.288 20.4c-3.113-2.662-7.125-4.125-11.288-4.125-4.162 0-8.175 1.463-11.287 4.125-.3.225-.338.638-.075.938.225.262.637.3.937.075 2.888-2.438 6.6-3.788 10.463-3.788 3.862 0 7.575 1.35 10.462 3.788.113.112.262.15.413.15a.605.605 0 0 0 .487-.226c.225-.3.188-.712-.112-.937Z",
    fill: "#163144"
  })));
};
export default SvgUser;